<script setup lang="ts">
import { defineProps, defineEmits } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps<{
    example: string;
}>();

const emits = defineEmits<{
    (event: 'handleExampleChange', example: string): void;
}>();

function handleExampleChange() {
    emits('handleExampleChange', props.example);
}
</script>

<template>
    <div
        class="translation-original-input-example mt-2 flex w-[640px] flex-col items-center"
    >
        <span class="y-1 mb-2 shrink-0 pr-2 text-xs text-grey-90">
            {{ t('aiDisclosure.sampleLabel') }}
        </span>

        <span
            class="line-clamp-1 cursor-pointer text-ellipsis rounded bg-blue-40 px-1 text-sm leading-6 text-primary"
            @click="handleExampleChange"
            v-html="example"
        />
    </div>
</template>
